export const BULK_TABS = {
    FILE_UPLOAD: "File Upload",
    TEXT_INPUT: "Text Input",
} as const;

export const UPDATE_TABS = [ "Manual Update", "Bulk Update" ];
export const UPDATE_INVENTORY_TABS = [ ...UPDATE_TABS, "Use Template" ];